import React from 'react'
import useSWRImmutable from 'swr/immutable'

import SelectBox from '../ui/selectBox'
import { getCurrencies } from '../../api'
import { StaticCurrency } from '../../lib/currencies'
import Spinner from '../ui/spinner'

type Props = {
  onChange: (e: any) => void,
  defaultValue?: string
  value?: string
  disabled?: boolean
  label?: string
}

const CurrencySelector: React.FC<Props> = ({
  defaultValue,
  value,
  onChange,
  label = 'Currency',
}) => {
  const { data: currenciesData, isLoading } = useSWRImmutable('/api/invoices/currencies', getCurrencies)
  const options = currenciesData?.map((currency: StaticCurrency) => ({
    label: `${currency.name} | ${currency.symbol}`,
    value: currency.code,
  }))
  if (isLoading) return <Spinner />
  return (
    <SelectBox
      label={label}
      id='currencyCode'
      name='businessDetails.currency.code'
      options={options}
      defaultValue={value === undefined ? (defaultValue as string) : undefined}
      value={value}
      onChange={onChange}
      required
    />
  )
}

export default CurrencySelector
